import React, { useState } from 'react';
import styled from 'styled-components';

import { Eye, EyeOff } from '@/assets/icons';

interface IShowPassProps {
  inputElementName: string;
}

const ShowPass = (props: IShowPassProps): React.ReactElement => {
  const [icon, setIcon] = useState(EyeOff);

  const togglePass = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const currentInputType = document.getElementsByName(props.inputElementName)[0].getAttribute('type');
    const newInputType = currentInputType === 'password' ? 'text' : 'password';
    document.getElementsByName(props.inputElementName)[0].setAttribute('type', newInputType);

    setIcon(icon === EyeOff ? Eye : EyeOff);
  };

  return (
    <StyledButton onClick={e => togglePass(e)}>
      <Icon src={icon} alt={''} />
    </StyledButton>
  );
};

ShowPass.displayName = 'ShowPass';

export { ShowPass };

const StyledButton = styled.button`
  position: absolute;
  background: transparent;
  border: none;
  top: 39px;
  right: 16px;
  cursor: pointer;
`;

const Icon = styled.img``;
